import React from "react";

import { Removable } from "@planzone/dto";
import { Tag } from "@common/tag";
import { InfoTagsBox } from "./infoTagsBox";
import { Props } from "./types";
import styles from "./styles.scss";

function TagsList({ tags, removableId, project }: Props) {
  const slicedTags = tags.slice(0, 3);
  const lastTags = tags.slice(3);

  return (
    <div className={styles.tagsList}>
      {slicedTags.map((tag, key) => (
        <Tag
          key={key}
          tag={tag}
          project={project}
          removable={Removable.RESSOURCE}
          removableId={removableId}
        />
      ))}
      {tags.length - 3 > 0 && (
        <div className={styles.hiddenTags}>
          <p className={styles.number}>+{tags.length - 3}</p>
          <div className={styles.infoBox}>
            <div className={styles.arrow} />
            <InfoTagsBox tags={lastTags} />
          </div>
        </div>
      )}
    </div>
  );
}

export { TagsList };
